<template>
  <div :style="{fontFamily: commitmentStatusText.fontFamily}">
    <span :style="{color: commitmentStatusText.color}">
      {{commitmentStatusText.text}}
    </span>
    {{commitmentTextAsProp}}
    <!-- <pre> {{commitment}} </pre> -->
    <font-awesome-icon
      v-if="editIcon"
      icon="wrench"
      @click="onEditCommitment"
      style="cursor: pointer; margin-right: 0.4em"/>
  </div>
</template>

<script>
import CommitmentMixin from '@/components/Inline/CommitmentMixin'

export default {
  props: {
    commitment: {
      required: true
    },
    editIcon: {
      default: true
    }
  },
  mixins: [CommitmentMixin],
  computed: {
    commitmentTextAsProp() {
      // console.log("commitmentTextAsProp");
      return this.commitmentText( this.commitment );
    },
    commitmentStatusText() {
      let { color, text } = this.commitmentStatusColorAndText( this.commitment );
      return {
        text: text,
        fontFamily: "Arial", // TODO
        color: color
      };
    },
  },
  methods: {
    onEditCommitment() {
      this.$root.showUpdateModal('effort', {
        goalId: this.commitment.goalId,
        commitmentId: this.commitment.commitmentId
      });
    },
  }
}
</script>
